import { render, staticRenderFns } from "./MyLoadsResponsive.vue?vue&type=template&id=465ca3a0&scoped=true"
import script from "./MyLoadsResponsive.vue?vue&type=script&lang=js"
export * from "./MyLoadsResponsive.vue?vue&type=script&lang=js"
import style0 from "./MyLoadsResponsive.vue?vue&type=style&index=0&id=465ca3a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ca3a0",
  null
  
)

export default component.exports